import IconCheck from "../../assets/svg/check.svg";
import IconStopwatch from "../../assets/svg/stopwatch.svg";
import IconQuestion from "../../assets/svg/question.svg";
import IconExclamation from "../../assets/svg/exclamation.svg";
import { sortListBetHome } from "../functions/FunctionsFilter";
import { managerClonerBetHome, listClones } from "../../global/GlobalVariables";
export const exchangeBetHome = [
  "BolsaDeAposta",
  "Bet-Bra",
  "Betfair EX",
  "Matchbook",
];
export const sportsbookBetHome = [];


export const globalBettingHouses = [
    "21Bets",
    "747Live",
    "AllBritishCasino",
    "Bet25",
    "BetFury",
    "Betcityru",
    "Betista",
    "Betonline",
    "Betostar",
    "Betovo",
    "Betpanda",
    "Betrebels",
    "Betwhale",
    "Casinado",
    "Cazimbo",
    "Cloudbet",
    "Crashino",
    "Crownplay",
    "CsgoEmpire",
    "DonBet",
    "DuckDice",
    "Duel",
    "FEZbet",
    "Fortunejack",
    "GoldSpin",
    "Goldenbet",
    "HiperWin",
    "Jack",
    "Jackpotter",
    "Kalshi",
    "Leon349",
    "Lucky Block",
    "Malina",
    "MundoApostas",
    "Mystake",
    "NovaJackpot",
    "Piwi247",
    "Polymarket",
    "Rabona",
    "Rainbet",
    "Rollbit",
    "Rolletto",
    "Roobet",
    "Rubet",
    "SlotsNBets",
    "Spassino",
    "Sportsbet",
    "Stake",
    "Superboss",
    "TG·Casino",
    "TheRedLion",
    "Thrill",
    "True Luck",
    "Trustdice",
    "Vavada",
    "VeloBet",
    "WSMCasino",
    "Winna",
    "freshbet"
]

export const normalBetHome = [
    "1pra1",
    "4Play",
    "4WIN",
    "6R",
    "7Games",
    "9fbet",
    "Afun",
    "Alfabet",
    "Aposta1",
    "ApostaBet",
    "ApostaOnline",
    "Apostaganha",
    "Apostamax",
    "Apostatudo",
    "Apostou",
    "AviaoBet",
    "B1Bet",
    "BR4",
    "BandBet",
    "BateuBet",
    "Bet-Bra SB",
    "Bet-Bra TB",
    "Bet.Bet",
    "Bet365",
    "Bet4",
    "Bet7k",
    "BetBoom",
    "BetDáSorte",
    "BetEsporte",
    "BetFalcons",
    "BetMGM",
    "BetPix365",
    "Betano",
    "Betapp",
    "Betboo",
    "Betfair SB",
    "Betfast",
    "Betfusion",
    "Betgorillas",
    "Betnacional",
    "Betou",
    "Betsul",
    "Betvip",
    "Betwarrior",
    "Betão",
    "Bigbet",
    "BingoPlus",
    "Bingobet",
    "Blaze",
    "BrBet",
    "BraBet",
    "Brasildasorte",
    "BravoBet",
    "Brazino777",
    "Brx",
    "Bullsbet",
    "CBEsportes",
    "Cassino",
    "Donald",
    "DonosdaBola",
    "EsportesDaSorte",
    "EsportivaVIP",
    "Esportivabet",
    "EstrelaBet",
    "F12Bet",
    "Faz1bet",
    "FazObet",
    "Fogo777",
    "Ganheibet",
    "Geralbet",
    "Ginga.bet",
    "Goldebet",
    "H2Bet",
    "Hiperbet",
    "Ijogo",
    "Jogao",
    "Jogodeouro",
    "Jonbet",
    "Kingpanda",
    "Kto",
    "LancedeSorte",
    "Lider",
    "Lotogreen",
    "Lottoland",
    "Lottu",
    "LuckBet",
    "Luvabet",
    "MarjoSports",
    "MaximaBet",
    "McGames",
    "MeridianBet",
    "MilhãoBet",
    "MmaBet",
    "Multibet",
    "NoviBet",
    "Oleybet",
    "OnaBet",
    "Onlybets",
    "P9",
    "Pagol",
    "PinBet",
    "Pinnacle",
    "Pixbet",
    "PlayBet",
    "R7Bet",
    "Reals",
    "ReidoPitaco",
    "Rico",
    "Rivalo",
    "Segurobet",
    "SeuBet",
    "SorteOnline",
    "Sortenabet",
    "Sportingbet",
    "SportyBet",
    "Stake",
    "StartBet",
    "Superbet",
    "SupremaBet",
    "Tivobet",
    "Tradicional",
    "UPBET",
    "UltraBet",
    "Vaidebet",
    "Vbet",
    "Vera",
    "Vivasorte",
    "Vupi",
    "WjCassino",
    "XXbet",
    "Zeroum",
    "ZonadeJogo",
    "energia.bet",
    "ice.bet",
    "nossabet"
].concat(exchangeBetHome)
  .concat(sportsbookBetHome);

export const allBetHome = [
    ...globalBettingHouses,
    ...normalBetHome,
];

export const quantityBetHomeToSkip =
  exchangeBetHome.length + sportsbookBetHome.length;

export const newListBetHomesSorted = sortListBetHome(
  managerClonerBetHome,
  allBetHome.slice(0, allBetHome.length - quantityBetHomeToSkip),
);

export const globalBettingHousesLower = globalBettingHouses.map(item => item.toLowerCase());
export const normalBetHomeLower = normalBetHome.map(item => item.toLowerCase());

export const listBetHomeMinuscle = [ ...globalBettingHousesLower, ...normalBetHomeLower ];

export const listBettingHousesNoClone = listBetHomeMinuscle.filter(item => !listClones.includes(item))


export const sportsPart1 = [
  "Artes Marciais",
  "Badminton",
  "Bandy",
  "Basquete",
  "Basquete 3x3",
  "Basquete 4x4",
  "Beisebal",
  "Boliche",
  "Cricket",
  "Dardos",
  "Floorball",
  "Futebol",
  "Futebol 3x3",
  "Futebol 4x4",
  "Futebol 5x5",
  "Futebol Americano",
  "Futebol Australiano",
  "Futebol Gaélico",
  "Futebol de Praia",
  "Futebol de Salão",
];
export const sportsPart2 = [
  "Futsal",
  "Golfe",
  "Handebol",
  "Handebol de Praia",
  "Hurling",
  "Hóquei",
  "Hóquei de Ar",
  "Hóquei de Ar 2x2",
  "Hóquei em Campo",
  "Lacrosse",
  "Netbol",
  "O que Onde Quando",
  "Pólo Aquático",
  "Rugby",
  "Sinuca",
  "Tênis",
  "Tênis de Mesa",
  "Voleibol",
  "Voleibol de Praia",
  "Xadrez",
];

export const esports = [
  "Arena of Valor",
  "Call of Duty",
  "Counter-Strike",
  "Dota",
  "E-Futebol",
  "King of Glory",
  "League of Legends",
  "NBA2K",
  "Overwatch",
  "Rainbow",
  "Rocket League",
  "StarCraft",
  "Valorant",
  "Warcraft",
];

export const allSportsMinuscle = [
  "arena of valor",
  "artes marciais",
  "badminton",
  "bandy",
  "basquete",
  "basquete 3x3",
  "basquete 4x4",
  "beisebal",
  "boliche",
  "cricket",
  "call of duty",
  "counter-strike",
  "dardos",
  "dota",
  "e-futebol",
  "floorball",
  "futebol",
  "futebol 3x3",
  "futebol 4x4",
  "futebol 5x5",
  "futebol americano",
  "futebol australiano",
  "futebol gaélico",
  "futebol de praia",
  "futebol de salão",
  "futsal",
  "golfe",
  "handebol",
  "handebol de praia",
  "hurling",
  "hóquei",
  "hóquei de ar",
  "hóquei de ar 2x2",
  "hóquei em campo",
  "king of glory",
  "lacrosse",
  "league of legends",
  "nba2k",
  "netbol",
  "o que onde quando",
  "overwatch",
  "pólo aquático",
  "rainbow",
  "rocket league",
  "rugby",
  "sinuca",
  "starcraft",
  "tênis",
  "tênis de mesa",
  "valorant",
  "voleibol",
  "voleibol de praia",
  "warcraft",
  "xadrez",
];

export const listKeysToCheck = [
  "betHome",
  "sports",
  "timeEvent",
  "filterOrder",
  "minProfit",
  "maxProfit",
  "marketsUnselected",
  "blacklistWordsSurebet",
];

export const listValueItemAccepted = {
  betHome: "object",
  sports: "object",
  timeEvent: "string",
  filterOrder: "string",
  minProfit: "number",
  maxProfit: "number",
  marketsUnselected: "object",
  blacklistWordsSurebet: "object",
};

export const listKeyItemsToUpdateInLocalStorage = {
  betHome: "listBehomeEnabled",
  sports: "listSportsEnabled",
  timeEvent: "time",
  filterOrder: "classificationSurebet",
  minProfit: "profitMin",
  maxProfit: "profitMax",
  marketsUnselected: "marketsUnselected",
  blacklistWordsSurebet: "blacklistWords",
};

export const warningBetHome = {
  bet365: "green",
  bet7: "gray",
  "bet-bra tb": "gray",
  betpix365: "green",
  betwarrior: "orange",
  "betano": "green",
  betboo: "orange",
  "betfair sb": "green",
  betfast: "red",
  betnacional: "green",
  betsul: "orange",
  betway: "orange",
  esportesdasorte: "green",
  estrelabet: "green",
  kto: "orange",
  leovegas: "orange",
  marjosports: "gray",
  novibet: "green",
  pinnacle: "green",
  pixbet: "green",
  seubet: "green",
  sportingbet: "orange",
  sportsbet: "green",
  stake: "green",
  superbet: "orange",
  vaidebet: "green",
  "vbet": "green",
  bolsadeaposta: "green",
  "bet-bra": "green",
  "betfair ex": "green",
  "bet-bra sb": "green",
  betvip: "green",
  faz1bet: "red",
  tivobet: "red",
  "7games": "gray",
  segurobet: "green",
  bet7k: "green",
  apostaganha: "green",
  brabet: "gray",
  tradicional: "gray",
  betão: "gray",
  r7bet: "gray",
  bingoplus: "gray",
  bravobet: "gray",
  h2bet: "gray",
  supremabet: "gray",
  maximabet: "gray",
  f12bet: "green",
  luvabet: "green",
  sportybet: "green",
  blaze: "green",
  betboom: "red",
  bingobet: "gray",
  pinbet: "gray",
  aviaobet: "gray",
  apostou: "gray",
  meridianbet: "green",
  pagol: "green",
  apostatudo: "green",
  betgorillas: "green",
  sortenabet: "green",
  betfusion: "green",
  vera: "green",
  cassino: "green",
  apostamax: "green",
  brx: "green",
  bullsbet: "green",
  donald: "green",
  jonbet: "green",
  jogodeouro: "green",
  reals: "green",
  lider: "green",
  geralbet: "green",
  bateubet: "gray",
  aposta1: "green",
  brbet: "gray",
  brasildasorte: "gray",
  bandbet: "red",
  b1bet: "green",
  "bet.bet": "green",
  betdásorte: "green",
  betou: "green",
  rico: "green",
  jogao: "green",
  "9fbet": "red",
  ijogo: "red",
  wjcassino: "red",
  bet4: "green",
  apostabet: "green",
  fazobet: "green",
  sorteonline: "gray",
  lottoland: "gray",
  br4: "green",
  goldebet: "green",
  lotogreen: "green",
  bigbet: "green",
  luckbet: "green",
  "1pra1": "green",
  startbet: "gray",
  onabet: "green",
  betmgm: "gray",
  matchbook: "green",
  betesporte: "green",
  rivalo: "red",
  lancedesorte: "green",
  esportivabet: "green",
  multibet: "green",
  reidopitaco: "green",
  hiperbet: "green",
  mmabet: "green",
  betfalcons: "green",
  "6r": "red",
  betapp: "red",
  p9: "red",
  mcgames: "green",
  ultrabet: "gray",
  esportivavip: "gray",
  donosdabola: "gray",
  cbesportes: "gray",
  milhãobet: "red",
  brazino777: "red",
  oleybet: "gray",
  kingpanda: "green",
  fogo777: "red",
  lottu: "green",
  "ice.bet": "gray",
  playbet: "green",
  "ganheibet": "green",
  vupi: "green",
  upbet: "gray",
  nossabet: "gray",
  alfabet: "gray",
  vivasorte: "gray",
  zeroum: "gray",
  zonadejogo: "gray",
  apostaonline: "gray",
  onlybets: "gray",
  xxbet: "gray",
  afun: "gray",
  "4play": "gray",
  "4win": "gray",
  "energia.bet": "gray",
  "ginga.bet": "gray",

      "21bets": "gray",
    "747live": "gray",
    "allbritishcasino": "gray",
    "bet25": "gray",
    "betfury": "gray",
    "betcityru": "gray",
    "betista": "gray",
    "betonline": "gray",
    "betostar": "gray",
    "betovo": "gray",
    "betpanda": "gray",
    "betrebels": "gray",
    "betwhale": "gray",
    "casinado": "gray",
    "cazimbo": "gray",
    "cloudbet": "gray",
    "crashino": "gray",
    "crownplay": "gray",
    "csgoempire": "gray",
    "donbet": "gray",
    "duckdice": "gray",
    "duel": "gray",
    "fezbet": "gray",
    "fortunejack": "gray",
    "goldspin": "gray",
    "goldenbet": "gray",
    "hiperwin": "gray",
    "jack": "gray",
    "jackpotter": "gray",
    "kalshi": "gray",
    "leon349": "gray",
    "lucky block": "gray",
    "malina": "gray",
    "mundoapostas": "gray",
    "mystake": "gray",
    "novajackpot": "gray",
    "piwi247": "gray",
    "polymarket": "gray",
    "rabona": "gray",
    "rainbet": "gray",
    "rollbit": "gray",
    "rolletto": "gray",
    "roobet": "gray",
    "rubet": "gray",
    "slotsnbets": "gray",
    "spassino": "gray",
    "sportsbet": "gray",
    "superboss": "gray",
    "tg·casino": "gray",
    "theredlion": "gray",
    "thrill": "gray",
    "true luck": "gray",
    "trustdice": "gray",
    "vavada": "gray",
    "velobet": "gray",
    "wsmcasino": "gray",
    "winna": "gray",
    "freshbet": "gray"
};

export const warningBetHomeMessages = {
  green: "Casa boa",
  gray: "Casa em teste",
  orange: "Casa boa - limita rápido",
  red: "Casa não recomendada",
};

export const warningBetHomeIcons = {
  green: IconCheck,
  gray: IconQuestion,
  orange: IconStopwatch,
  red: IconExclamation,
};

export const dangersMarket = ["Cartões", "Estatísticas"];

const firstListMarketsOnfilterMarket = [
  "Cartões",
  "Classificação",
  "Empate Anula (DNB)",
  "Escanteios",
  "Estatísticas",
  "Handicap",
  "Pênalties",
  "Resultados",
  "Totais",
  "Ímpar/Par",
  "Sim/Não",
  "Resultado correto (pontuação)",
  "Aces",
  "Lay (contra)",
  "Ambos marcam",
];

export const listSecondaryMarkets = {
  Estatísticas: [
    "Chutes a gol",
    "Chutes e finalizações",
    "Impedimentos",
    "Assistências",
    "Desarmes",
    "Faltas",
    "Lateral (reposições)",
    "Roubo de bola",
    "Cestas de três",
  ],

  Handicap: ["Asiático", "Europeu"],
};

const keysListSecondaryMarkets = Object.keys(listSecondaryMarkets);

for (let i = 0; i < keysListSecondaryMarkets.length; i++) {
  let keyMarket = keysListSecondaryMarkets[i];

  let index = firstListMarketsOnfilterMarket.indexOf(keyMarket);

  firstListMarketsOnfilterMarket.splice(
    index + 1,
    0,
    ...listSecondaryMarkets[keyMarket],
  );
}

export const listMarketsOnfilterMarket = firstListMarketsOnfilterMarket;

export const quantityMarkets = listMarketsOnfilterMarket.length;

export const newListBetHome = [
  "zeroum",
  "zonadejogo",
  "apostaonline",
  "onlybets",
  "xxbet",
  "afun",
  "playbet",
  "cbesportes",
  "donosdabola",
  "esportivavip",
  "luvabet",
  "startbet",
  "bravobet",
  "betão",
  "7games",
  "r7bet",
  "bingoplus",
  "lottu"
];

export const betHomeNoLimit = [
  "pinnacle",
  "bet-bra",
  "bolsadeapostas",
  "betfair ex",
  "matchbook",
  "bet-bra tb",
];

export const betHomeGlobal = [
    "21bets",
    "747live",
    "allbritishcasino",
    "bet25",
    "betfury",
    "betcityru",
    "betista",
    "betonline",
    "betostar",
    "betovo",
    "betpanda",
    "betrebels",
    "betwhale",
    "casinado",
    "cazimbo",
    "cloudbet",
    "crashino",
    "crownplay",
    "csgoempire",
    "donbet",
    "duckdice",
    "duel",
    "fezbet",
    "fortunejack",
    "goldspin",
    "goldenbet",
    "hiperwin",
    "jack",
    "jackpotter",
    "kalshi",
    "leon349",
    "lucky block",
    "malina",
    "mundoapostas",
    "mystake",
    "novajackpot",
    "piwi247",
    "polymarket",
    "rabona",
    "rainbet",
    "rollbit",
    "rolletto",
    "roobet",
    "rubet",
    "slotsnbets",
    "spassino",
    "sportsbet",
    "superboss",
    "tg·casino",
    "theredlion",
    "thrill",
    "true luck",
    "trustdice",
    "vavada",
    "velobet",
    "wsmcasino",
    "winna",
    "freshbet",
    "stake",
];


export const listBettingHousesUnregulated = [
  "marjosports",
]